module.exports = __webpack_public_path__ + "static/media/bdl.8868ab95.svg";